
import { computed, defineComponent, reactive } from 'vue'

// components
import PageTitle from '@/common/components/UI/PageTitle/index.vue'
import TheButton from '@/common/components/UI/TheButton/index.vue'

// module compponents
import StepClient from '@/modules/CreateOrderModule/components/StepClient/index.vue'
import StepSendersSpark from '@/modules/CreateOrderModule/components/StepSendersSpark/index.vue'
import StepDateSpark from '@/modules/CreateOrderModule/components/StepDateSpark/index.vue'
import StepReceiversSpark from '@/modules/CreateOrderModule/components/StepReceiversSpark/index.vue'
import StepCreate from '@/modules/CreateOrderModule/components/StepCreate/index.vue'

// types
import { Client, SenderSpark } from '@/new-services/types/orders'

// composable
import useNotifications from '@/common/composable/useNotifications'
import { useRouter } from 'vue-router'
import { useFormData } from '@/common/composable/useFormData'

// realisations
import ordersAPI from '@/new-services/orders.service'

export default defineComponent({
    components: {
        PageTitle,
        TheButton,
        StepClient,
        StepSendersSpark,
        StepDateSpark,
        StepReceiversSpark,
        StepCreate,
    },
    setup() {
        const router = useRouter()
        const notifications = useNotifications()
        const { getFormData } = useFormData()

        const state = reactive({
            is_creating_order: false,
            is_order_created: false,
            is_excel_loading: false,
        })

        const payload = reactive({
            clientId: null as number | null,
            senderTemplateId: null as number | null,
            pickupDate: null as string | null,
            directions: null as File | null,
        })

        // clients actions
        const onClientSubmit = (client: Client) => {
            payload.clientId = client.id
        }

        // senders actions
        const onSenderSubmit = (sender: SenderSpark) => {
            payload.senderTemplateId = sender.id
        }

        const onSenderReset = () => {
            payload.senderTemplateId = null
        }

        // date actions
        const onDateSubmit = (date: string) => {
            payload.pickupDate = date
        }

        const onDateReset = () => {
            payload.pickupDate = null
        }

        // receiver actions
        const onReceiverSubmit = (directions: File) => {
            if (!directions) return
            payload.directions = directions
        }

        const onReceiverReset = () => {
            payload.directions = null
        }

        //

        const resetOrder = () => {
            state.is_order_created = false

            payload.pickupDate = null
            payload.senderTemplateId = null
            payload.pickupDate = null
            payload.directions = null
        }

        const onSubmitOrder = async () => {
            try {
                state.is_creating_order = true

                await ordersAPI.createOrderSpark(getFormData(payload))

                notifications.notify({
                    title: 'Заказ создан',
                    type: 'success',
                })

                state.is_order_created = true
                router.push('/')
            } catch (error) {
                console.error(error)
                notifications.notifyError({ error, title: 'При создании заказа произошла ошбика' })
            } finally {
                state.is_creating_order = false
            }
        }

        // computeds
        const isClientSelected = computed(() => Boolean(payload.clientId))
        const isSenderSelected = computed(() => Boolean(payload.senderTemplateId))
        const isDateSelected = computed(() => Boolean(payload.pickupDate))
        //
        const isDisabled = computed(() =>
            Boolean(state.is_creating_order || state.is_order_created)
        )
        const isCreate = computed(() => {
            return Boolean(
                payload.clientId &&
                    payload.directions &&
                    payload.pickupDate &&
                    payload.senderTemplateId
            )
        })

        //

        return {
            state,
            payload,
            // client
            onClientSubmit,
            // sender
            onSenderSubmit,
            onSenderReset,
            // date
            onDateSubmit,
            onDateReset,
            // receiver
            onReceiverSubmit,
            onReceiverReset,
            // computeds
            isClientSelected,
            isSenderSelected,
            isDateSelected,
            //
            isDisabled,
            isCreate,
            // create
            onSubmitOrder,
            resetOrder,
        }
    },
})
